import { currencyFormatter } from '@/helpers/currencyFormatter';
import { Box } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

// Link-only delivery: the link was created and stored but not sent to the customer.
const DirectPaymentLinkGenerated = ({ event }: { event: any }) => {
  const minAllowedPayment: number | undefined = event.data?.minAllowedPayment;
  return (
    <Box display="block">
      <Box as="span" display="inline-block" margin="0 2xs 0 0">
        <EventBy event={event} /> generated a direct payment link (not sent)
        {minAllowedPayment !== undefined && minAllowedPayment > 0
          ? ` with a minimum payment of ${currencyFormatter.format(minAllowedPayment)}`
          : ''}
      </Box>
    </Box>
  );
};

export default DirectPaymentLinkGenerated;
